export default __webpack_public_path__ + "static/media/logo512.64b43ccb.png";